export const POST_MUTATION_KEYS = {
  /** Shared by all post-creation mutations (gossip, happening, offer, …). */
  CREATE: 'post_create',
  /** Shared by all post-edit mutations (change gossip, change happening, …). */
  CHANGE: 'post_change',
  /** Shared by poll create/delete mutations that follow a post change. */
  POLL: 'post_poll'
} as const;
